function openTab(tabName) {
    var i;
    var x = document.getElementsByClassName("tab");
    var y = document.getElementsByClassName('btn-tab');
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
      y[i].classList.remove('pdp-clicked-tab');
    }
    document.getElementById(tabName).style.display = "block";  
    document.getElementById('btn-'+tabName).classList.add('pdp-clicked-tab');
  }